import { Pipe, PipeTransform } from "@angular/core";
@Pipe({ name: "decimalNumber" })
export class decimalNumberPipe implements PipeTransform {
  transform(data: any): any {
    return data.toFixed(2);
  }
}
